import { CompanyAPI } from '@api';

const getCreditFlags = async () => CompanyAPI.getCreditFlags()
  .then(({ data }) => data)
  .catch((error) => Promise.reject(error.response));

export { getCreditFlags };
